/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import React, { useContext, useEffect, useState } from 'react';
import {
  getFilterDepartment,
  getFilterManager,
  getFilterRep,
  getFilterTeams,
} from '../../../api/ninetyReport';
import useReportContext from '../context/useReportContext';

function Filter() {
  const { auth, filterForm, adminAccess, setFilterForm, searchReport, clearReport } =
    useContext(useReportContext);
  const [managerOptions, setManagerDrowndown] = useState([]);
  const [repOptions, setRepDrowndown] = useState([]);
  const [departmentOptions, setDepartmentDrowndown] = useState([]);
  const [teamsOptions, setTeamsDrowndown] = useState([]);

  const loadDepartmentDropdown = async () => {
    let departmentDropdown;
    const request = {
      keyword: '',
    };
    const reponse = await getFilterDepartment(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row,
        label: row,
      }));

      if (data.length === 1) {
        setFilterForm({ ...filterForm, department: dropdownValue[0] });
        departmentDropdown = dropdownValue;
      } else {
        departmentDropdown = [{ label: 'ALL', value: null }, ...dropdownValue];
      }
      setDepartmentDrowndown(departmentDropdown);
    }
  };

  const loadTeamsDropdown = async () => {
    const request = {
      department: filterForm?.department?.value,
      manager_id: '',
      date_from: filterForm?.date_from,
      date_to: filterForm?.date_to,
      month: [],
      years: [],
      keyword: '',
    };
    const reponse = await getFilterTeams(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data
        ?.filter((row) => row.team !== null)
        .map((row) => ({
          value: row.team,
          label: row.team,
        }));
      setTeamsDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
      // if (dropdownValue.length < 2) {
      //   setFilterForm({ ...filterForm, team: dropdownValue[0] });
      // } else {
      //   setFilterForm({ ...filterForm, team: { label: 'ALL', value: null } });
      // }
    }
  };

  const loadRepDropdown = async () => {
    // const request = {
    //   department: filterForm?.department?.value,
    //   manager_id: adminAccess.includes(auth.designation)
    //     ? filterForm?.manager_id?.value
    //     : auth.user_id,
    //   date_from: filterForm?.date_from,
    //   date_to: filterForm?.date_to,
    //   month: [],
    //   year: [],
    //   keyword: '',
    // };
    const request = {
      department:
        departmentOptions.length > 2 ? filterForm?.department?.value : departmentOptions[1]?.value,
      manager_id: adminAccess.includes(auth.designation)
        ? filterForm?.manager_id?.value
        : auth.user_id,
      rep_id: adminAccess.includes(auth.designation) ? filterForm?.manager_id?.value : auth.user_id,
      team: filterForm?.team?.value,
      date_from: '2024-07-01',
      date_to: '2024-07-26',
      month: [],
      year: [],
      keyword: '',
    };
    const reponse = await getFilterRep(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.rep_id,
        label: row.rep_name,
      }));
      setRepDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadManagersDropdown = async () => {
    const request = {
      department:
        departmentOptions.length > 2 ? filterForm?.department?.value : departmentOptions[1]?.value,
      head_id: null,
      keyword: null,
    };
    const response = await getFilterManager(request);
    const { code, data } = response.data;

    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.manager_id,
        label: row.manager_name,
      }));
      setManagerDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeDate = (label, value) => {
    const tmpdate = new Date(value);
    const newdate = `${
      tmpdate.getMonth() > 8 ? tmpdate.getMonth() + 1 : `0${tmpdate.getMonth() + 1}`
    }-${
      tmpdate.getDate() > 9 ? tmpdate.getDate() : `0${tmpdate.getDate()}`
    }-${tmpdate.getFullYear()}`;

    setFilterForm({ ...filterForm, [label]: newdate });
  };

  useEffect(() => {
    loadDepartmentDropdown();
    loadRepDropdown();
    loadManagersDropdown();
    loadTeamsDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        {departmentOptions.length > 1 && auth.designation === 'hidden' ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='department'
              disableClearable
              fullWidth
              options={departmentOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Deparment' />}
              size='small'
              value={filterForm?.department}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}

        <Grid md={1}>
          <Autocomplete
            disablePortal
            id='team'
            disableClearable
            fullWidth
            options={teamsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Teams' />}
            size='small'
            value={filterForm?.team}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        {auth.level === 'Level 3' || auth.level === 'Level 4' ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='manager_id'
              disableClearable
              fullWidth
              options={managerOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Manager' />}
              size='small'
              value={filterForm.manager_id}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'manager_id')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}

        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Medical Representative' />}
            size='small'
            value={filterForm.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        <Grid md={1}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='YYYY-MM-DD'
            value={filterForm.date_from}
            onChange={(e) => handleChangeDate('date_from', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>

        <Grid md={1}>
          <DesktopDatePicker
            label='Date To'
            inputFormat='YYYY-MM-DD'
            value={filterForm.date_to}
            onChange={(e) => handleChangeDate('date_to', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={4}>
          <Button variant='contained' color='success' onClick={searchReport}>
            Generate
          </Button>

          <Button
            variant='contained'
            color='primary'
            onClick={clearReport}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
